import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Filters from '../../../../components/Filters';
import { setFilters, setSelectedFilterId } from '../../actions';
import { getFilters } from '../../selectors';

const FiltersToolbar = ({
  presets,
  simpleFilters,
  optionsSelector,
  optionsSubscription,
}) => {
  const dispatch = useDispatch();
  const filters = useSelector(getFilters);
  const handleOnChange = useCallback(
    (newFilters) => {
      dispatch(setFilters(newFilters));
    },
    [dispatch],
  );
  const handleOnChangeSavedFilters = useCallback(
    (filterId) => {
      dispatch(setSelectedFilterId(filterId));
    },
    [dispatch],
  );
  const handleResetSavedFiltersId = useCallback(() => {
    handleOnChangeSavedFilters();
  }, [handleOnChangeSavedFilters]);

  return (
    <div className="stack-2">
      <div className="cluster-2">
        <Filters
          presets={presets}
          value={filters}
          simpleFilters={simpleFilters}
          onChange={handleOnChange}
          onSubmit={handleResetSavedFiltersId}
          optionsSelector={optionsSelector}
          optionsSubscription={optionsSubscription}
          onResetSavedFilters={handleOnChangeSavedFilters}
        />
      </div>
    </div>
  );
};

FiltersToolbar.propTypes = {
  presets: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  simpleFilters: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  optionsSubscription: PropTypes.func,
  optionsSelector: PropTypes.shape({
    all: PropTypes.func,
  }),
};

FiltersToolbar.defaultProps = {
  presets: [],
  simpleFilters: null,
  optionsSubscription: () => {},
  optionsSelector: null,
};

export default FiltersToolbar;
